<template>
<div style="margin-bottom: 15px;">
  <div class="columns" v-show="!isEditing" v-bind:class="showActiveBorder(data.status)">
      <div class="column is-three-quarters">
        <p class="subtitle">
          {{ data.name }}
        </p>
      </div>
      <div class="column is-one-quarter">
        <div class="field has-addons" style="float: right">
          <button class='button is-small is-success' v-on:click="goManageStudents(data)" style="margin-right: 10px;">
            Manage Students
          </button>
          <div class='extra content'>
            <span class='right floated edit icon' v-on:click="showForm">
                <font-awesome-icon icon="edit" />
              <!-- <i class='edit icon'></i> -->
            </span>
            <span class='right floated trash icon' v-on:click="deleteData(data)">
              <font-awesome-icon icon="trash-alt" />
              <!-- <i class='trash icon'></i> -->
            </span>
          </div>
        </div>
      </div>
  </div>
  <div class="columns" style="margin-bottom: 10px;" v-show="isEditing">
    <div class="column is-5">
      <p class="control">
        <input class="input" type="text" placeholder="Group Name, eg: Homeroom" v-model="data.name" name="updateName">
      </p>
    </div>
    <div class="column is-3">
      <p class="control">
          <v-select multiple v-model="data.teachers" :options="options" label="firstName" key="_id"></v-select>
      </p>
    </div>
    <div class="column is-2">              
      <div class="field" style="margin-top: 5px;">
        <div class="control">
            <label class="radio">
                <input type="radio" :name="data.status" v-model="data.status" value="1" >
                Active
            </label>
            <label class="radio">
                <input type="radio" :name="data.status" v-model="data.status" value="0">
                Inactive
            </label>
        </div>
      </div>
    </div>
    <div class="column is-2">
        <button class='button is-primary' v-on:click="hideForm(data)">OK</button>
        <button class="button is-warning" v-on:click="closeForm()">X</button>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    props: ['data'],
    data() {
        return {
            options: [],
            isEditing: false,
        };
    },
    created() {
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.defaults.responseType = 'json'
        axios.post(process.env.MY_URL + '/api/teachers/list', {
                params: {
                    email: localStorage.getItem('email'),
                    sessionID: localStorage.getItem('sessionID')
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                this.options = response.data
            })
            .catch(e => {
                this.errors.push(e)
                console.log("Error: " + e)
            })
    },
    methods: {
      showActiveBorder(isActive){
        if (isActive == "1"){
          return "status-active-contents";
        }else{          
          return "status-inactive-contents";
        }
      },
      deleteData(data) {
          this.$emit('delete-data', data);
      },
      showForm() {
          this.isEditing = true;
      },
      hideForm(data) {
          this.$emit('update-data', data);

          this.isEditing = false;
      },
      closeForm(){
        this.isEditing = false;
      },
      goManageStudents(data){
        this.$store.commit('UPDATE_VIEW_GROUP_ID',data._id)
        this.$store.commit('UPDATE_VIEW_GROUP_NAME',data.name)
        localStorage.setItem('VIEW_GROUP_ID',data._id)
        localStorage.setItem('VIEW_GROUP_NAME',data.name)
        this.$router.push({
            name: "DbGroupManageStudents"
        });
      }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Database/Group/DataView.vue